import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { preview } from '@/components/form/preview'

import { selectCompanies } from '@/features/domain/company'
import { selectUserConfiguration } from '@/features/domain/user'
import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Company(props: Props) {
  const { extOrder } = props

  const { planType } = useSelector(selectUserConfiguration)
  const companies = useSelector(selectCompanies)
  const texts = useTexts()

  const company = useMemo(() => {
    const archived = planType === 'archived'
    const companyId = extOrder.order.companyId
    const hasZombieCompany = companyId !== null && !companies[companyId]

    return archived
      ? (extOrder.order.archivedData?.companyName ?? '-')
      : companyId === null || hasZombieCompany
        ? null
        : (companies[companyId]?.name ?? null)
  }, [extOrder, planType])

  return (
    <preview.Field label={texts.company.label}>{company ?? <preview.NullValue />}</preview.Field>
  )
}
